"use client"

import dynamic from 'next/dynamic';

// Import the shared types and constants
import { type LightboxConfig } from './lightbox.types';

// Dynamically import the client component with ssr: false
// This ensures the CSS is only loaded client-side
// We don't need to use the component, just importing it loads the CSS
dynamic(() => import('./lightbox.client'), {
  ssr: false,
});

// Export the createLightbox function
export const createLightbox = async (config: LightboxConfig) => {
  // Dynamically import the function from the client module
  const { createLightbox } = await import('./lightbox.client');
  return createLightbox(config);
};
